import { Route, Routes } from 'react-router-dom'
import { useState } from 'react'
import Login from './Login'
import BarLoader from 'react-spinners/BarLoader'
import { AuthContext } from './AuthContext'

function App({ project, ad }) {
  const [isLoading, setIsLoading] = useState(false)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'absolute' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />
      <AuthContext.Provider value={{ setIsLoading, isLoading }}>
        <Routes>
          <Route
            path="/"
            element={
              <Login setIsLoading={setIsLoading} project={project} ad={ad} />
            }
          />
        </Routes>
      </AuthContext.Provider>
    </>
  )
}

export default App
